import styles from '../../styles/main.scss';
import Engine from './engine.js';

document.addEventListener('DOMContentLoaded', new Engine().init());